// src/services/planningService.ts
// src/services/planningService.ts

import apiClient from '../utils/apiClient';
import { 
  SongSearchResult, 
  PlanningData, 
  UpdateSelectionsRequest 
} from '../components/planning/types'; // Updated import path

export interface PlanningFilters {
  liturgicalYear?: string;
  churchIds?: number[];
}

export const fetchPlanningData = async (filters: PlanningFilters = {}): Promise<PlanningData> => {
  try {
    const params: any = {};

    if (filters.liturgicalYear) {
      params.liturgicalYear = filters.liturgicalYear;
    }

    if (filters.churchIds && filters.churchIds.length > 0) {
      params.churchIds = filters.churchIds.join(',');
    }

    const response = await apiClient.get<PlanningData>('/planning', {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching planning data:', error);
    throw error;
  }
};

export const fetchLiturgicalYearWithNextService = async (churchIds?: number[]): Promise<{ id: number; year: string } | null> => {
  try {
    const params: any = {};

    if (churchIds && churchIds.length > 0) {
      params.churchIds = churchIds.join(',');
    }

    const response = await apiClient.get<{ id: number; year: string }>('/planning/next-service-year', {
      params,
    });

    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status === 404) {
      return null;
    }
    console.error('Error fetching liturgical year with next service:', error);
    throw error;
  }
};



/**
 * The liturgical year the given churches are actually active in — used so that
 * choosing a church you no longer serve takes you to its years rather than to
 * an empty page in the present one.
 */
export const fetchNearestServiceYear = async (churchIds?: number[]): Promise<{ id: number; year: string } | null> => {
  try {
    const params: any = {};

    if (churchIds && churchIds.length > 0) {
      params.churchIds = churchIds.join(',');
    }

    const response = await apiClient.get<{ id: number; year: string }>('/planning/nearest-service-year', {
      params,
    });

    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status === 404) {
      return null;
    }
    console.error('Error fetching nearest service year:', error);
    return null;
  }
};


interface SongSearchResponse {
  songs: SongSearchResult[];
}

export const searchSongs = async (term: string): Promise<SongSearchResponse> => {
  try {
    const response = await apiClient.get<SongSearchResponse>('/song-selections/search', {
      params: { term }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching songs:', error);
    throw error;
  }
};



// src/services/planningService.ts

export const updateSongSelections = async (updateRequest: UpdateSelectionsRequest) => {
  console.log('[planningService] Making update request:', updateRequest);
  try {
    const response = await apiClient.put('/song-selections/update-selections', updateRequest);
    console.log('[planningService] Raw response:', response);
    
    // Check if the response has the expected structure
    if (response.data && (response.data.added || response.data.updated || response.data.deleted)) {
      return {
        success: true,
        ...response.data
      };
    } else {
      console.error('[planningService] Unexpected response structure:', response.data);
      throw new Error('Invalid response structure from server');
    }
  } catch (error) {
    console.error('[planningService] Update error:', error);
    throw error;
  }
};